import {
    EYEGLASSES_CATEGORY_ID,
    SUNGLASSES_CATEGORY_ID,
    CONTACT_LENSES_CATEGORY_ID,
    PLA_CONTACT_LENSES_CATEGORY_ID,
    PRESCRIPTION_CATEGORY_ID,
} from 'constants/category';

type ProductType = 'sunglasses' | 'eyeglasses' | 'contacts' | '';

/**
 * Getting categories ids, which exist in dy data feed and return type of product
 * @param {string[]} categoryIds id of category for product, ex: ['174','12'...]
 * @returns {ProductType} return type of product
 */
export const getProductType = (categoryIds: string[]): ProductType => {
    if (categoryIds.includes(SUNGLASSES_CATEGORY_ID)) return 'sunglasses';
    if (categoryIds.includes(EYEGLASSES_CATEGORY_ID)) return 'eyeglasses';
    if (
        categoryIds.some(
            id => id === CONTACT_LENSES_CATEGORY_ID || id === PLA_CONTACT_LENSES_CATEGORY_ID,
        )
    )
        return 'contacts';
    return '';
};

/**
 * Getting product type and return contacts or not
 * @param {ProductType} productType type of product
 * @returns {boolean} boolean
 */
export const isContactsProduct = (productType: ProductType) => productType === 'contacts';
/**
 * Getting product type and return contacts or not
 * @param {categoryIds} categoryIds - array of categories IDs
 * @returns {boolean} boolean
 */
export const isPrescriptionSG = (categoryIds: string[]): boolean =>
    categoryIds.includes(PRESCRIPTION_CATEGORY_ID) && getProductType(categoryIds) === 'sunglasses';
